// this file is currently unused
import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { Link, useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import {
  FormikForm,
  Section,
  AgGridDataTable,
  TonnageDisclaimer,
  Breadcrumbs,
} from "../../../shared";
import * as yup from "yup";
import { CSVLink, CSVDownload } from "react-csv";
import urlParameterHelper from "../../../../utilities/urlParameters";
const date = new Date();

export default function ExportTqrDetailDataToCsv(props) {
  const backToUrl = "/reports";
  const pageTitle = "Export TQR Detail Data to CSV";
  const location = useLocation();
  const history = useHistory();
  const params = queryString.parse(location.search);
  const searchOnInit = Object.keys(params).length > 0 ? true : false;
  const initialFormValues = {
    fromDate: params && params.fromDate ? params.fromDate : "",
    toDate: params && params.toDate ? params.toDate : "",
    county: params && params.county ? params.county : "",
  };

  const [results, setResults] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [isBadRequest, setIsBadRequest] = useState(false);
  const [resultMsg, setResultMsg] = useState();
  const apiEndpoint = "/api/v1/hwts/search/tqrreport/detail";
  const schema = yup.object({
    county: yup.string(),
  });

  const formConfig = [
    {
      name: "fromDate",
      config: {
        col: "md",
        colWidth: "3",
        label: "Ship From Date",
        placeholder: "",
        type: "date",
      },
    },
    {
      name: "toDate",
      config: {
        col: "md",
        colWidth: "3",
        label: "Ship To Date",
        placeholder: "",
        type: "date",
      },
    },
    {
      name: "county",
      config: {
        col: "md",
        validate: true,
        colWidth: "3",
        label: "Select a County",
        placeholder: "Select a County",
        type: "select",
        apiEndpoint: "api/v1/hwts/search/counties",
        hasApi: true,
      },
    },
  ];

  const search = async (formData, formik) => {
    const qs = urlParameterHelper.stringify(formData);
    window.history.replaceState(null, 'Hazardous Waste Tracking System', `${location.pathname}?${qs}`);

    setIsFetching(true);
    setResultMsg();
    axios
      .get(`${apiEndpoint}?${qs}`)
      .then((res) => {
        setResults(res.data);
        setIsFetching(false);
        formik.setSubmitting(false);
      })
      .catch((err) => {
        if (err.response.status === 400) {
          let requiredFields = new Object();
          setResults([]);
          setIsFetching(false);
          setIsBadRequest(true);
          setResultMsg("No results found matching your search criteria.");
          formik.setSubmitting(false);
          Object.keys(err.response.data).forEach((key, i) => {
            requiredFields = {
              ...requiredFields,
              [key]: err.response.data[key][0],
            };
          });

          formik.setErrors(requiredFields);
        }
      });
  };

  const onSubmit = async (formData, formik) => {
    search(formData, formik);
  };
  return (
    <React.Fragment>
      <Section
        title={
          <Link to={backToUrl} style={{ color: "white" }}>
            Export TQR Detail Data to CSV
          </Link>
        }
        type={"standout"}
      />
      <div className="container">
        <Breadcrumbs
          breadcrumbs={[
            { name: "HWTS Reports", url: "/reports", active: false },
            {
              name: "Export TQR Detail Data to CSV",
              url: "",
              active: true,
            },
          ]}
        />
        <FormikForm
          initialFormValues={initialFormValues}
          schema={schema}
          formConfig={formConfig}
          onSubmit={onSubmit}
        />
        {isFetching == true ? (
          <div className="m-b-md" style={{ margin: "auto", width: "1%" }}>
            <div class="loader"></div>
          </div>
        ) : results.length > 0 && !isFetching ? (
          <div style={{ display: "flow-root" }}>
            <div className="m-b-md">
              <CSVLink
                data={results}
                filename={`TQRDetailRpt_${date.toLocaleDateString(
                  "en-US"
                )}.csv`}
                className="btn btn-primary btn-lg btn-block-xs m-t-md m-b-md full-width"
                target="_blank"
              >
                Download File
              </CSVLink>
            </div>
          </div>
        ) : (
              <div></div>
            )}
        {isBadRequest == true ? (
          <div className="m-b-md" style={{ textAlign: "center" }}>
            {resultMsg}
          </div>
        ) : (
            <div className="m-b-sm"></div>
          )}
        <TonnageDisclaimer />
      </div>
    </React.Fragment>
  );
}
